export enum PlannerMode {
  FloorPlan = 0,
  Layout = 1,
  FixturePlan2D = 2,
  FixturePlan3D = 3,
  FixturePhotosphere = 4,
  Layout3D = 5,
  LayoutPhotosphere = 6,
}
